import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    //通知列表 1:我收到的通知 2：我申请的通知
    getNotice(data)
    {
        return axios.request({
            url: "user/notification",
            data
        })
    }
}
